import React from "react";
import styles from "./BaseVideo.module.scss";
import { VideoLoading } from "../components/VideoLoading/VideoLoading";
export function BaseVideo(_ref) {
  var createBlobUrl = _ref.createBlobUrl,
    loading = _ref.loading;
  if (loading) return /*#__PURE__*/React.createElement(VideoLoading, null);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("video", {
    className: styles.baseVideo,
    controls: true,
    src: createBlobUrl === null || createBlobUrl === void 0 ? void 0 : createBlobUrl.objectURL
  }));
}